<script>
import { TheMask } from 'vue-the-mask'

import { apiSecond } from '@/boot/axios'

export default {
	components: {
		TheMask,
	},
	props: {
		user: {
			type: Object,
		},
	},
	data() {
		return {
			list: [],
			totalItems: null,
			errorMessage: {
				status: null,
				text: null,
				messages: null,
			},
			message: {
				status: null,
				text: null,
			},

			blockElemet: null,
			unlockElemet: null,

			filters: {
				iin_bin: '',
			},
			options: {
				itemsPerPage: 10,
				page: 1,
			},
			headers: [
				{ text: 'Id', value: 'id', width: '50px' },
				{
					text: this.$t('headers.name_company') + ' / ' + this.$t('headers.fio'),
					value: 'name_company',
					width: '23vw',
				},
				{ text: this.$t('headers.iin_bin'), value: 'iin_bin', sortable: false, width: '10vw' },
				{ text: this.$t('headers.pond'), value: 'quota_ponds', sortable: false, width: '10vw' },
				{ text: this.$t('headers.register_at'), value: 'created_at', width: '10vw' },
				{
					text: this.$t('headers.action'),
					value: 'action',
					align: 'left',
					sortable: false,
					width: '200px',
				},
			],

			fileDocuments: {
				file: null,
				fileName: '',
				fileClass: '',
			},
		}
	},
	beforeCreate() {
		if (!localStorage.token) this.$router.push('/ru/login')
	},
	methods: {
		search() {
			this.options.page = 1
			this.pagination(this.options)
		},
		pagination(options) {
			this.apiGetUserDocumentList(options.page, options.itemsPerPage)
		},
		apiGetUserDocumentList(page = 1, per_page = 10) {
			let regions = []
			this.$store.state.userObject.regions?.find((element) => {
				regions.push(element.region_id)
			})
			const params = {
				regions: regions,
				...(this.filters.iin_bin
					? { 'filter[search]': this.filters.iin_bin.replaceAll(' ', '') }
					: {}),
				page,
				per_page,
			}
			apiSecond
				.get('v1/user/region/list', {
					params,
				})
				.then((response) => {
					if (response.data) {
						this.list = response.data.data
						this.totalItems = response.data.total
					}
				})
				.catch((error) => {
					if (error?.response?.status == 500) {
						this.errorMessage.status = 500
						this.errorMessage.text = this.$t('system_message.500')
					}
					if (error?.response?.status == 401) {
						this.errorMessage.status = 401
						this.errorMessage.text = error.response.data.error_message
						this.$router.push('/' + this.$i18n.locale + '/login')
					}
					if (error?.response?.status == 422) {
						this.errorMessage.status = 422
						this.errorMessage.text = error.response.data.error_message
					}
					if (error?.response?.status == 403) {
						this.errorMessage.status = 403
						this.errorMessage.text = error?.response?.data?.message
					}
				})
		},
		handleFileUpload() {
			this.message.status = null
			this.message.text = null
			this.message.texts = null
			this.errorMessage = {
				status: null,
				text: null,
				messages: null,
			}
			this.fileDocuments.file = this.$refs.fileDocuments.files[0]
			this.fileDocuments.fileName = this.$refs.fileDocuments.files[0].name
			this.fileDocuments.fileClass = 'add_tourist--success'
		},
	},
	head: {
		title() {
			return {
				inner: this.$t('sidebar.users_parent'),
			}
		},
		meta: [],
	},
}
</script>

<template>
	<div
		class="wrap__content"
		v-bind:class="{ 'wrap__content--preloader': !list || !$store.state.userObject }"
	>
		<v-preloader v-if="!$store.state.userObject" :message="errorMessage"></v-preloader>

		<div class="container" v-if="$store.state.userObject">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['DocumentManagementSupervisor']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title">
									<div class="content__title--element">
										<div class="content__title--text">
											{{ $t('sidebar.documents') }}
										</div>
									</div>
								</div>
							</div>
							<div class="card__content--body">
								<div class="table__block--content">
									<div class="mb-3">
										<div class="row items-center">
											<div class="col-3">
												<label class="search__label">
													<TheMask
														v-model="filters.iin_bin"
														:placeholder="$t('headers.iin_bin')"
														:mask="['### ### ### ###']"
														:masked="true"
														type="text"
														name="filter_search"
													/>
												</label>
											</div>
											<div class="col-3">
												<div class="form__btns">
													<button class="input-btn form__line--btn" @click="search">
														{{ $t('button.find') }}
													</button>
												</div>
											</div>
										</div>
									</div>

									<v-data-table
										:headers="headers"
										:items="list"
										:loading="false"
										:options.sync="options"
										:server-items-length="totalItems"
										:footer-props="{
											'items-per-page-options': [5, 10, 20, 30, 40, 50],
										}"
										@update:options="pagination"
									>
										<template v-slot:item.name_company="{ item }">
											{{ item.name_company }} <br />
											{{ item.first_name }} {{ item.last_name }} {{ item.middle_name }}
										</template>
										<template v-slot:item.quota_ponds="{ item }">
											{{ item.quota_ponds.map((i) => i.title).join(', ') }}
										</template>
										<template v-slot:item.created_at="{ item }">
											<div>
												{{ new Date(item.created_at).toLocaleDateString() }}
											</div>
										</template>

										<template v-slot:item.action="{ item }">
											<div class="flex">
												<router-link
													v-if="$store.getters.userPermission(['read_document_all'])"
													:to="'/' + $i18n.locale + '/account/documents-list/' + item.id + '/list'"
													class="tb__table--btn tb__table--view"
													v-tooltip.top-center="{
														content: $t('tooltip.look'),
														class: ['tooltip__btn'],
													}"
												>
													<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9 16.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 12l3-3-3-3M6 9h6" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
												</router-link>
											</div>
										</template>
										<v-alert slot="no-results" :value="true" color="error">
											{{ $t('system_message.search') }}
										</v-alert>
									</v-data-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
header .header__row {
	display: flex;
}
</style>
